module.exports = __webpack_public_path__ + "static/media/Manufacturing-Banner@2x.a4bad5e0.jpg";